module.exports = __webpack_public_path__ + "static/media/PB-RACE-BLUE-WIDE-2.43383575.svg";